import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GridComponent, PageSettingsModel, RowDataBoundEventArgs, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { GridPageSettings, LocalStorageKeys, MenuFuncionCodes } from '../../../../../src/app/shared/model';
import { ComunidadService, MenuFuncionService } from '../../../../../src/app/shared/services';
import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';
import { HttpErrorResponse } from '@angular/common/http';
import { EventEmiterService } from '../../../../../src/app/shared/services/event-emiter.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-vencimientoSeguros',
  templateUrl: './vencimientoSeguros.component.html',
  styleUrls: ['./vencimientoSeguros.component.scss']
})

export class VencimientoSegurosComponent implements OnInit {

  @ViewChild('grid')
  public grid: GridComponent;

  isValidating: boolean = false;
  canView: boolean = false;
  isSearching: boolean = false;
  formGroup: FormGroup;

  public data: DataManager;
  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  private subscription: Subscription;

  constructor(
    private sharedFunctions: SharedFunctions,
    private comunidadService: ComunidadService,
    private formBuilder: FormBuilder,
    private menuService: MenuFuncionService,
    private eventEmitterService: EventEmiterService
  ) {
    this.subscription = this.eventEmitterService.reloadView$.subscribe((value) => {
      this.loadView()
    });
   }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.DASHBOARD_SEGUROS_VENCIMIENTO).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result) {
        this.canView = true;
        this.loadView();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };


    this.buildForm();

    this.setQueryParams();
    this.data = new DataManager({
      url: this.comunidadService.getServiceUrl() + '/dashboard-seguros',
      adaptor: new WebApiAdaptor(),
      headers: [this.comunidadService.getAuthorizationHeader(),this.comunidadService.getTenantHeader()]
    });
  }

  buildForm(){
    this.formGroup = this.formBuilder.group({
      "CantidadDias": [30, [Validators.min(1)]]
    })
  }

  getTraduccion(value: string) {
    return this.sharedFunctions.getNombreMenuTenant(value);
  }

  onGridActionFailure(event: any): void {
    // this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "CantidadDias");
    if (index >= 0)
      this.query.params[index].value = this.formGroup.value.CantidadDias;
    else
      this.query.addParams("CantidadDias",this.formGroup.value.CantidadDias);

    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    if (cId != null && cId > 0) {
      index = this.query.params.findIndex(obj => obj.key === "ConsorcioId");
      if (index >= 0)
        this.query.params[index].value = cId;
      else
        this.query.addParams("ConsorcioId", cId);
    }
  }

  loadDashboard() {
    if (!this.formGroup.valid) {
      const controls = this.formGroup.controls;
      Object.keys(controls).forEach(controlName => controls[controlName].markAsTouched());
      return false;
    }

    this.setQueryParams();
    this.grid.refresh();
  }

  getErrorCantidadDias(): string{
    return this.formGroup.get("CantidadDias")?.hasError('min') ? 'Debe ingresar al menos 1 dia' : '';
  }

  onCantidadDiasChange() {
    var d = this.formGroup.get("CantidadDias")?.value;
    if (d == null || d <= 0)
      this.formGroup.get("CantidadDias")?.setValue(1);

    // console.log("Dias>>"+d);
    this.loadDashboard();
  }

  rowDataBound(args: RowDataBoundEventArgs) {
    const VigenciaHasta = 'VigenciaHasta';
    // Obtener la fecha de hoy
    const hoy: Date = new Date();
    const vigenciaHastaToDate = new Date(args.data?.[VigenciaHasta]);
    // Agregarle 7 días
    const oneMonth: Date = new Date(hoy.getTime() + 30 * 24 * 60 * 60 * 1000);
    const twoMonth: Date = new Date(hoy.getTime() + 60 * 24 * 60 * 60 * 1000);

    if (oneMonth >= vigenciaHastaToDate) {
      args.row?.classList.add('critical');
    } else if (vigenciaHastaToDate >= oneMonth && vigenciaHastaToDate < twoMonth) {
      args.row?.classList.add('warning');
    } else {
      args.row?.classList.add('ok');
    }
  }
}
